export default {
  'm': {
    'uploading': 'Yükleniyor...',
    'upload_failed': 'Yükleme başarısız',
    'EnterID': 'BuzzCast Id\'yi girmek için tıklayın',
    'select-specifications': 'Şarj teknik özelliklerini seçmek için tıklayın',
    'check-account': 'Şarj hesabını kontrol edin',
    'whatID': 'BuzzCast Kimliği nedir?',
    'getID': 'BuzzCast Kimliğini Girin',
    'maskgetID': 'BuzzCast Kimliğini Girin',
    'toastTips-format-error': 'Giriş biçimi yanlış',
    'toastTips-no-exist': 'Kimlik yok',
    'toastTipsPlease': 'Lütfen önce şarj hesabını kontrol edin',
    'transaction-succeeded': 'İşlem başarılı oldu',
    'PayStatusSuccess_title': 'İşlem başarılı oldu',
    'transaction-failed': 'Hareket başarısız oldu',
    'PayStatusFail_title': 'Hareket başarısız oldu',
    'transaction-cancel': 'İşlem iptal edildi',
    'PayStatusCancel_title': 'İşlem iptal edildi',
    'buy-notice-a': 'Not: <a>{msg}</a> BuzzCast için tek resmi elmas satın alma web sitesi',
    'replace': 'Değiştirmek',
    'Diamonds_title': '{msg} Diamond Şarj Resmi Web Sitesi',
    'openAPP': 'BuzzCast APP\'i aç',
    'description': 'BuzzCast sadece resmi elmas şarj sitesi, BuzzCast uluslararası bir sosyal yazılım, 150\'den fazla ülke ve dünya çapında bölgeler BuzzCast kullanıyorsunuz',
    'keywords': 'BuzzCast şarj, BuzzCast elmas şarj, BuzzCast resmi şarj, BuzzCast resmi şarj web sitesi',
    'wxPay': 'WeChat ödemesinin tamamlandığını lütfen onaylayın',
    'Completed': 'Ödeme tamamlandı',
    'toastTips-no-complete': 'Ödeme tamamlanmadı, lütfen tekrar ödeyin',
    'RechargeHelp_title': 'Şarj Yardımı',
    'RechargeProblem_title': 'Şarj işleminizde bir sorun oluştu,',
    'feedback_and_help': 'Geri Bildirim ve Yardım',
    'problem_screenshot': 'Soru ekran görüntüsü/ekran kaydı ({msg})',
    'problem_description': 'Soru açıklaması',
    'problem_description_placeholder': 'Lütfen karşılaştığınız soruyu açıklayın',
    'optional': 'isteğe bağlı',
    'required': 'gerekli',
    'buy-enter-link': 'Satın alma elmas bağlantı üzerinden şarj edilebilir, <a class="web-link" href="https://pay.buzzcast.info">https://pay.buzzcast.info</a> Açmak için mobil tarayıcıda bağlantıyı kopyalayın, hesap kontrol ettikten sonra, satın alma sayfasına girin, ilgili özellikleri seçin ve indirimler ~ Çok ödemek için uygun ödeme yöntemini kullanın!',
    'buy-diamonds-tit': 'Satın alma Elmas Servisi',
    'buy-notice': 'Not pay.buzzcast.info BuzzCast tek resmi elmas satın alma web sitesi, müşteri hizmetleri sorgulamaiçin, lütfen [Mesaj]-[Resmi Haberler]-[Geribildirim ve Yardım] girin',
    'common-problem': 'Sık karşılaşılan sorun',
    'rechargeFAQ_title': 'Sık karşılaşılan sorun',
    'whether-account': 'Şarj olduktan sonra hesabın alınıp alınmadığını nasıl kontrol edebilirim?',
    'answer-whether-account': 'Şarj ettikten sonra, elmasları görüntülemek için APP\'in [My]-[Cüzdan]',
    'no-account': 'Şarj olduktan sonra hesabı alamazsam ne olur?',
    'answer-no-account': 'Lütfen sorularınızı APP\'in [Mesaj]-[Resmi Haberler]-[Geri Bildirim ve Yardım] adresine gönderin ve aşağıdaki bilgileri sağlayın, müşteri hizmetlerimiz size yardımcı olacaktır.',
    'recharge-money': '1. Şarj tutarı ve hesap kimliği',
    'recharge-time': '2. Şarj saati ve tarihi',
    'recharge-shot': '3. Başarılı ödeme ekran görüntüsü',
    'recharge-wrong': 'Yanlış hesap ve yanlış tutardan ücret alırsam ne yapmalıyım?',
    'answer-recharge-wrong': 'Ödeme şifresini girmeden önce, lütfen şarj hesabı kimliğini dikkatlice onayladığınızı ve satın alma işlemi yapmak için tutar bilgilerini şarj etmeyi unutmayın. Yanlış ücret in miktarı iade edilemez. Yanlış ücret hesabı için, gerçekte şarj ettiğiniz kimlik kullanıcısıyla iletişime geçebilir ve şarjınızı tazmin etmek istiyorlarsa karşı tarafla görüşebilirsiniz.',
    'refund': 'Iade',
    'answer-refund': 'Üzgünüm! BuzzCast şu anda herhangi bir geri ödeme biçimini desteklememektedir.',
    'sureBtn': 'Onaylamak',
    'pay-style': 'Ödeme yöntemini seçin',
    'goBack': 'Ana sayfaya dön',
    'toastTips': 'BuzzCast Kimliğini Girin',
    'payforType': 'Yükleme Yöntemi',
    'trueText': 'Onaylamak',
    'falseText': 'İptal',
    'alertShowTxt1': 'Bạn có chắc chắn sử dụng',
    'alertShowTxt3': 'để nạp',
    'alertShowTxt5': 'kim cương không?',
    'EnterIDTip': '{msg} hızlı şarj',
    'scanLogin': 'Hesap gizliliği ve güvenliği için lütfen giriş yapmak için kodu tarayın',
    'scanTip': 'İpucu: Oturum açmak için kodu taramak üzere BuzzCast "Kişisel Merkez / Dinamikler" in sağ üst köşesindeki "Tara" düğmesine tıklayın. Aynı zamanda, QR kodu ekran görüntüsünü tanımlayarak oturum açmayı destekler',
    'scanVersion': 'Lütfen BuzzCast\'I %s sürümüne yükseltin ve oturum açmak için kodu tarayın',
    'delAccount': 'Hesap silme',
    'logout': 'Oturum aç',
    'submit': 'Submit',
    'email_place_holder': 'Please enter your email address',
    'fill_in_email_address': 'Lütfen e-posta adresini doldurun',
    'fill_in_all_required': 'Lütfen soru açıklamasını girin',
    'order_exception_notice': 'Sıcak hatırlatma: Anormal şarj siparişleri için sipariş numarası veya fatura ekran görüntüsü sağlanmalıdır',
    'cannot_read_file': 'Dosya okunamıyor',
    'upload_file_exceed_limit': 'Yüklenen dosya {num} MB\'yi aşamaz',
    'submitting': 'Gönderiliyor...',
    'submit_failed': 'Gönderme başarısız',
    'contact_email': 'Contact E-mail',
    'provide_email': 'Please provide your E-maii address for payment order',
    'email_address': 'E-mail Addrerss',
    'sel_country_area': 'Ülke veya Bölge Seçiniz',
    'search_for': 'Arama',
    'login': 'Oturum aç',
    'scan_login': 'Tarama kodu girişi',
    'account_password_error': 'Yanlış Telefon Numarası veya Şifre',
    'user_frozen': 'Kullanıcı donduruldu',
    'account_no_reg': 'Hesap kayıtlı değil',
    'login_no': 'Giriş yapmadın',
    'login_after_recharge': 'Giriş yaptıktan sonra şarj edebilirsiniz',
    'scan_login_lesson': 'Tarama kodunun eğitimi Giriş',
    'scan_login_desc': 'Kaydetme kodunu tarama yöntemi, şarj web sitesini giriş yapmak için hızlı ve güvenli bir şekilde gerçekleştirebilir. Aşağıdaki iki yöntem sırasıyla giriş yapmanın nasıl taranacağını tanıtır.',
    'scan_login_a_title': 'QR kodunun ekran görüntülerini tanıyarak giriş yapın',
    'scan_login_a_p1': '1. Tek cihazın senaryosunu kullanmak için daha uygundur. Kullanıcı, şarj web sitesinin giriş sayfasına girer, "Giriş yapmak için kodu tarama" seçeneğini tıklatın ve sayfanın ekran görüntüsünü Oturum Açma QR Code görüntülenir ve albümü kaydeder. (Ekran görüntüsü işlevi farklı cihazlar için biraz farklıdır, ekran görüntüsü fonksiyonunun çalışma talimatlarını kendi başınıza arama yapabilirsiniz)',
    'scan_login_a_p2': '2. BuzzCast uygulamasını "Kişisel Merkez" veya "Dinamik" işlev modülü aracılığıyla, kod tarama fonksiyonu modülünü girmek için sağ üst köşedeki "Tarama" nı tıklayın.',
    'scan_login_a_p3': '3. "Albüm Seçimi" ne tıklayın ve Albüm İzinlerine İzin Verin, Kayıtlı QR Code Login sayfası ekran görüntüsünü seçin, sistem tanıdıktan sonra "Giriş" onay düğmesini tıklatın, tarayıcıya geri dönün ve bir süre bekleyin, sayfa otomatik olarak kullanıcı yüklenir bilgi.',
    'scan_login_b_title': 'QR kodunu tarayarak giriş yapın',
    'scan_login_b_p1': '1. Birden fazla cihazın kullanımı için daha uygundur. Kullanıcı, şarj web sitesinin giriş sayfasına girer ve "Tarama kodu girişi',
    'scan_login_b_p2': '2. Başka bir cihazdaki BuzzCast uygulamasını açın, "Kişisel Merkez" veya "Dinamik" işlev modülüne gidin ve kod tarama fonksiyonu modülünü girmek için sağ üst köşedeki "Tarayı" ı tıklayın.',
    'scan_login_b_p3': '3. Kod tarama kutusunu Kod tarama giriş sayfasındaki QR koduyla hizalayın, sistem tanıyıldıktan sonra "Oturum Aç" Onay düğmesine tıklayın (kodu tararken cihazlar arasında belirli bir mesafeyi korumak önerilir) sistemin tanıdığı için). Bir süre sonra, sayfa kullanıcı bilgilerini otomatik olarak yükleyecektir.',
    'scan_login_lesson_end': 'Yukarıdakiler, kod girişi taramak için bir eğitim kılavuzudur, size yardımcı olmayı umuyorum. Müşteri Hizmetleri Danışma için lütfen uygulama mesajı-resmi haber-geri bildirim ve yardıma girin.',
    'or': 'Veya',
    'input_phone_num': 'Lütfen cep telefonu numarasını girin',
    'input_email': 'Lütfen e-posta adresinizi girin',
    'input_password': 'Parola Girin',
    'log_in_using_Facebook': 'Facebook ile giriş yapın',
    'log_in_using_Google': 'Google ile giriş yapın',
    'account_or_pwd_error': 'Yanlış hesap veya şifre',
    'pay_fail_system_risk': 'İşlem başarısız oldu: sistem anormal',
    'recharge_fail_risk_network': 'Yükleme başarısız oldu. Yüksek riskli bir ağ ortamında olabilirsiniz veya başka nedenlerden dolayı. Yükleme konusunda yardıma ihtiyacınız varsa, lütfen sorununuzu bize bildirin.',
    'friendly_tip': 'Dostu İpuçları',
    'i_got_it': 'Anladım',
    'android_fblogin_tip': 'Facebook artık Android yerleşik tarayıcısında kimlik doğrulama girişini desteklemediğinden, bu şekilde giriş yaptığınızda giriş yapamayabilirsiniz. Bu tür bir oturum açma sorunuyla karşılaşırsanız, erişmek için lütfen Chrome tarayıcıyı kullanın.',
    'recharge_tip': 'Alınan elmasların belirli miktarı, gerçek şarj miktarına tabidir.',
    'charge': 'Yatır',
    'link_add_mainpage': 'Bir sonraki işlem kolaylılığı için  bağlantıyı ana ekrana ekleyin',
    'click_me_to_add': 'Eklemek içini tıklayın',
    'user_has_delete': 'Kullanıcı iptal edildi',
    'support_contant_whatsapp': 'Desteğe ihtiyacınız varsa, lütfen {msg} App\'tan müşteri hizmetleri ile iletişime geçin: 1924383',
    'buy_balance': 'Satın Alınabilir Bakiye:',
    'official_coin_seller': 'Resmi Madeni Para Tüccarı',
    'paystyle_unavailabel_change_other': 'Sistem anormal, bu ödeme yöntemi geçici olarak kullanılamıyor, diğer ödeme yöntemlerine geçebilirsiniz.',
    'failedPay': 'Ödeme bir sorunla karşılaştı. Lütfen yeni bir ödeme yapın.',
    "copied": "Kopyalandı",
    "reseller": "Yeniden Satıcı",
    "netword_busy_try": "Ağ meşgul, lütfen tekrar deneyin",
    "placecommen": 'Arama içeriğini girin',
    "app_all_v2": 'Tüm',

		"use_phone_login": `Telefon ile giriş yap`,
    "use_email_login": `E-posta ile giriş yap`,
    "device_is_more": "Bu cihaz için kayıtlı hesap sayısı üst sınıra ulaştı",
    "Operation_failed": "Bu cihaz hesap ihlalleri nedeniyle kalıcı olarak donduruldu",
    "connection_fail_retry_feedback": "Bağlantı başarısız oldu. Lütfen ağın sorunsuz çalıştığından emin olun ve tekrar deneyin. Hatalarla karşılaşmaya devam ederseniz, lütfen bize bildirin, en kısa sürede çözeceğiz.",
    "fawry_recharge_failed": "{method} ile ${msg} para yüklemesi başarısız oldu.",
    "feedback": "Geri bildirim",
    "problem_feedback": "Geribildirim",
    "recommended_recharge_methods": "Önerilen ödeme yöntemleri",
    "try_recharge_methods": "Lütfen aşağıdaki yöntemleri kullanarak yenilemeyi deneyin. Hala sorun yaşıyorsanız, bizimle iletişime geçmek için aşağıdaki \"{feedback}\" düğmesini tıklayın.",
    "unable_recharge": "Yeniden yüklenemiyor",
    "submitted_successfully": "başarıyla gönder",
    "feedback_success_tip": "Geri bildiriminiz için teşekkür ederiz, 24 saat içinde mümkün olan en kısa sürede ilgileneceğiz",
    "completed": "Tamamlayınız",
    'contact_information': 'İletişim bilgileri (isteğe bağlı)',
    'pay_failed': 'Ödeme başarısız',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/tr.js